module.exports = __webpack_public_path__ + "img/Dubbele_plooi.04140bcf.png";